import React, { Component } from "react";

import {
  authErrorMessages,
  requestUpdatePassword,
} from "../services/backendRequests";
import { AuthShell } from "../landing/AuthShell";
import { Link } from "react-router-dom";
import { PasswordInput } from "../landing/PasswordInput";
import PropTypes from "prop-types";

class PasswordEdition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      passwordConfirmation: "",
      submitting: false,
      success: false,
      messages: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ submitting: true });

    requestUpdatePassword(
      this.state.password,
      this.state.passwordConfirmation,
      this.props.location.search
    )
      .then((response) => {
        if (response.success) {
          this.setState({ success: true, messages: [response.message] });
          setTimeout(() => {
            window.location = "/";
          }, 5000);
        } else {
          this.setState({
            success: false,
            messages: authErrorMessages(response.errors),
          });
        }
      })
      // err.message, not err: an Error object rendered as a React child would
      // blow up the render instead of showing the message.
      .catch((err) =>
        this.setState({ success: false, messages: [err.message] })
      )
      .finally(() => this.setState({ submitting: false }));
  }

  render() {
    return (
      <AuthShell title="Choose a new password">
        <form className="lg-form" onSubmit={this.handleSubmit}>
          {this.state.messages.map((message) => (
            <div
              key={message}
              className={this.state.success ? "lg-success" : "lg-error"}
              role="alert"
            >
              {message}
            </div>
          ))}

          <div className="lg-field">
            <label htmlFor="new-password">New password</label>
            <PasswordInput
              id="new-password"
              name="password"
              value={this.state.password}
              onChange={(event) =>
                this.setState({ password: event.target.value })
              }
              autoComplete="new-password"
            />
          </div>

          <div className="lg-field">
            <label htmlFor="confirm-password">Confirm password</label>
            <PasswordInput
              id="confirm-password"
              name="passwordConfirmation"
              value={this.state.passwordConfirmation}
              onChange={(event) =>
                this.setState({ passwordConfirmation: event.target.value })
              }
              autoComplete="new-password"
            />
          </div>

          <button
            className="lg-submit"
            type="submit"
            disabled={this.state.password === "" || this.state.submitting}
          >
            Reset password
          </button>

          {this.state.success ? (
            <p className="lg-forgot">
              You will be redirected soon, or <a href="/">click here</a>.
            </p>
          ) : (
            <Link className="lg-forgot" to="/">
              Back to login
            </Link>
          )}
        </form>
      </AuthShell>
    );
  }
}

PasswordEdition.propTypes = {
  location: PropTypes.object.isRequired,
};

export default PasswordEdition;
